

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ListItem from '../core/ListItem.vue';

@Component({
  components: {
    listItem: ListItem
  }
})
export default class CartFormSelection extends Vue {
  @Prop({ type: Object, required: true }) action!: { data?: () => Promise<any[]> };

  private data: any[] | null = null;

  @Watch('action', { deep: true, immediate: true })
  async onActionChange(action: { data?: () => Promise<any[]> }) {
    if (action && action.data) {
      try {
        const data = await action.data();
        if (data) {
          this.data = data;
        }
      } catch (error) {
        this.$emit('error', error);
      }
    }
  }
}
